let bigDataRouter = [
  // {
  //   name: "兴隆山楂全产业链高质量发展项目",
  //   value: "xinglong",
  //   list: [
  //     {
  //       path: "/statisticalData",
  //       name: "大数据中心",
  //       component: () =>
  //         import("@/views/bigData/views/xingLong/statisticalData.vue"),
  //     },
  //     {
  //       path: "/industResourceData",
  //       name: "资源一张图",
  //       component: () =>
  //         import("@/views/bigData/views/xingLong/industResourceData.vue"),
  //     },
  //     {
  //       path: "/baseMap",
  //       name: "基地一张图",
  //       component: () => import("@/views/bigData/views/xingLong/baseMap.vue"),
  //     },
  //     {
  //       path: "/qualityAuditData",
  //       name: "质量监管一张图",
  //       component: () =>
  //         import("@/views/bigData/views/xingLong/qualityAuditData.vue"),
  //     },
  //     {
  //       path: "/tradePicture",
  //       name: "数字交易中心",
  //       component: () =>
  //         import("@/views/bigData/views/xingLong/tradePicture.vue"),
  //     },
  //     //   {
  //     //     path: "/overview",
  //     //     name: "产业总览",
  //     //     component: () => import("@/views/bigData/views/pengYang/overview.vue"),
  //     //   },
  //   ],
  // },
  {
    name: "兴隆山楂全产业链高质量发展项目",
    value: "xinglong",
    list: [
      {
        path: "/statisticalData",
        name: "大数据中心",
        component: () =>
          import("@/views/bigData/views/xingLongNew/statisticalData.vue"),
      },
      {
        path: "/industResourceData",
        name: "资源一张图",
        component: () =>
          import("@/views/bigData/views/xingLongNew/industResourceData.vue"),
      },
      {
        path: "/baseMap",
        name: "基地一张图",
        component: () => import("@/views/bigData/views/xingLongNew/baseMap.vue"),
      },
      {
        path: "/qualityAuditData",
        name: "质量监管一张图",
        component: () =>
          import("@/views/bigData/views/xingLongNew/qualityAuditData.vue"),
      },
      {
        path: "/tradePicture",
        name: "数字交易中心",
        component: () =>
          import("@/views/bigData/views/xingLongNew/tradePicture.vue"),
      },
      {
        path: "/qualityShanz",
        name: "山楂品质一张图",
        component: () =>
          import("@/views/bigData/views/xingLongNew/qualityShanz.vue"),
      },
      {
        path: "/hxcq",
        name: "全国山楂核心产区数据",
        component: () =>
          import("@/views/bigData/views/xingLongNew/hxcq.vue"),
      },
      //   {
      //     path: "/overview",
      //     name: "产业总览",
      //     component: () => import("@/views/bigData/views/pengYang/overview.vue"),
      //   },
    ],
  },
  {
    name: "华南优质中药材数字交易中心",
    value: "hnzyc",
    list: [
      {
        path: "/statisticalData",
        name: "大数据中心",
        component: () =>
          import("@/views/bigData/views/zhongShan/statisticalData.vue"),
      },
      {
        path: "/industResourceData",
        name: "资源一张图",
        component: () =>
          import("@/views/bigData/views/zhongShan/industResourceData.vue"),
      },
      {
        path: "/baseMap",
        name: "基地一张图",
        component: () => import("@/views/bigData/views/zhongShan/baseMap.vue"),
      },
      {
        path: "/qualityAuditData",
        name: "质量监管一张图",
        component: () =>
          import("@/views/bigData/views/zhongShan/qualityAuditData.vue"),
      },
      {
        path: "/tradePicture",
        name: "数字交易中心",
        component: () =>
          import("@/views/bigData/views/zhongShan/tradePicture.vue"),
      },
    ],
  },
  {
    name: "科右大数据",
    value: "kyzq",
    list: [
      {
        name: "科右大数据首页",
        path: "/ky",
        component: () =>
          import("@/views/bigData/views/keYou/bigDataContent.vue"),
        children: [
              {
                path: 'baseMap',
                name: '产业园发展概览',
                component: () => import('@/views/bigData/views/keYou/baseMap.vue')
            },
            {
              path: 'brandYuny',
              name: '品牌运营面板',
              component: () => import('@/views/bigData/views/keYou/brandYuny.vue')
            },
            {
              path: 'tradePicture',
              name: '产业交易中心',
              component: () => import('@/views/bigData/views/keYou/tradePicture.vue')
            },
            {
                path: 'qualityEvaluation',
                name: '肉牛品质评价',
                component: () => import('@/views/bigData/views/keYou/qualityCattle.vue')
            },
            {
              path: 'otherPage',
              name: '其他大数据',
              component: () => import('@/views/bigData/views/keYou/iframe.vue')
            },
            {
              path: 'dataCenter',
              name: '肉牛产业链',
              component: () => import('@/views/bigData/views/keYou/dataCenter.vue')
            },
        ],
      },
      
    ]
},
  {
    name: "彭阳县优质农产品全产业链",
    value: "pengyang",
    list: [
      {
        path: "/overview",
        name: "产业总览",
        component: () => import("@/views/bigData/views/pengYang/overview.vue"),
      },
      {
        path: "/digitalAquaculture",
        name: "数字养殖",
        component: () =>
          import("@/views/bigData/views/pengYang/digitalAquaculture.vue"),
      },
      {
        path: "/qualityAuditData",
        name: "数字监管",
        component: () =>
          import("@/views/bigData/views/pengYang/qualityAuditData.vue"),
      },
      {
        path: "/tradePicture",
        name: "数字交易",
        component: () =>
          import("@/views/bigData/views/pengYang/tradePicture.vue"),
      },
    ],
  },
  {
    name: "平乐柿子全产业链",
    value: "pingLe",
    list: [
      {
        path: "/statisticalData",
        name: "大数据中心",
        component: () =>
          import("@/views/bigData/views/pingLe/statisticalData.vue"),
      },
      {
        path: "/industResourceData",
        name: "资源一张图",
        component: () =>
          import("@/views/bigData/views/pingLe/industResourceData.vue"),
      },
      {
        path: "/qualityPersimmon",
        name: "品质柿子",
        component: () =>
          import("@/views/bigData/views/pingLe/qualityCattle.vue"),
      },
    ],
  },
  {
    name: "乌拉特前旗全产业链",
    value: "wulate",
    list: [
      {
        path: "/statisticalData",
        name: "大数据中心",
        component: () =>
          import("@/views/bigData/views/wulate/statisticalData.vue"),
      },
      {
        path: "/tradePicture",
        name: "农业产业交易中心",
        component: () =>
          import("@/views/bigData/views/wulate/tradePicture.vue"),
      },
      {
        path: "/baseMap",
        name: "数字种养中心",
        component: () =>
          import("@/views/bigData/views/wulate/baseMap.vue"),
      },
      {
        path: "/jgjc",
        name: "价格检测中心",
        component: () =>
          import("@/views/bigData/views/wulate/jgjc.vue"),
      },
      {
        path: "/cybz",
        name: "产业标准中心",
        component: () =>
          import("@/views/bigData/views/wulate/cybz.vue"),
          // children: [
          //   {
          //     path: 'baseMap',
          //     name: '产业园发展概览',
          //     component: () => import('@/views/bigData/views/keYou/baseMap.vue')
          //   },
          // ]
      },
      {
        path: "/pzpj",
        name: "品质评价中心",
        component: () =>
          import("@/views/bigData/views/wulate/pzpj.vue"),
      },
      {
        path: "/yqzz",
        name: "园区种植情况",
        component: () =>
          import("@/views/bigData/views/wulate/yqzz.vue"),
      },
      
    ],
  },
  {
    name: "潍坊数字交易中心",
    value: "weifang",
    list: [
      {
        path: "/tradePicture",
        name: "数字交易中心",
        component: () =>
          import("@/views/bigData/views/weifang/tradePicture.vue"),
      },
    ],
  },
  {
    name: "全球商通中心",
    value: "qqshangtong",
    list: [
      {
        path: "/operation",
        name: "全球商通中心运营支撑体系",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/operation.vue"),
      },
      {
        path: "/operationEn",
        name: "全球商通中心运营支撑体系En",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/operationEn.vue"),
      },
      {
        path: "/operationnew",
        name: "全球商通中心运营支撑体系1",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/operationnew.vue"),
      },
      {
        path: "/baseMap",
        name: "基地一张图",
        component: () => import("@/views/bigData/views/qiuanshangtong/baseMap.vue"),
      },
      {
        path: "/qualityShizi",
        name: "品质柿子",
        component: () =>
          import("@/views/bigData/views/pingLe/qualityCattle.vue"),
      },
      {
        path: "/qualityAuditData",
        name: "质量追溯",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/qualityAuditData.vue"),
      },
      {
        path: "/cybz",
        name: "国家及行业标准大数据",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/cybz.vue"),
      },
      {
        path: "/qualityEvaluation",
        name: "全球商通中心品质评价大数据展示",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/qualityEvaluation/index.vue"),
      },
      {
        path: "/rzxx",
        name: "认证信息",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/rzxx.vue"),
      },
      {
        path: "/tradePicture",
        name: "全球商通中心交易一张图",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/tradePicture.vue"),
      },
      {
        path: "/jgjc",
        name: "全国农产品产业监测中心",
        component: () =>
          import("@/views/bigData/views/qiuanshangtong/jgjc.vue"),
      },
    ],
  },
];
module.exports = bigDataRouter;
